import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SellerRoutingModule } from './seller-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from '../../core/core.module';
import { CheckboxModule } from 'primeng/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { SellerManageComponent } from './seller-manage/seller-manage.component';
import { SellerDetailComponent } from './seller-detail/seller-detail.component';
import { PreviewLogoComponent } from './preview-logo/preview-logo.component';

@NgModule({
  imports: [
    CommonModule,
    SellerRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CoreModule,
    CheckboxModule,
    TranslateModule,
    NgSelectModule
  ],
  declarations: [
    SellerManageComponent,
    SellerDetailComponent,
    PreviewLogoComponent
  ],
  entryComponents: [SellerDetailComponent]
})
export class SellerModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/seller.module.ts